module.exports = __webpack_public_path__ + "band_17_daughter.8fd9581a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_17_daughter.png
// module id = J1kA
// module chunks = 0